export class ADMappingModel {
  BBSFPropertyName: string;
  ADPropertyName: string;
  ADMappingTypeItemID: number;
  IncludeInUpdate: boolean;
}
